import React from "react";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import { Outlet, useLocation } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

function Layout() {
  const { pathname } = useLocation();

  return (
    <div className="layout">
      <Navbar />

      <main>
        <Outlet />
      </main>
      <ScrollToTop />
      {pathname !== "/contact" ? <Footer /> : null}
    </div>
  );
}

export default Layout;
